var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline:money-graph-arrow-increase-ascend-growth-up-arrow-stats-graph-right-grow",
    clipPath: "url(#clip0_463_1704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8574 4H15.4289V8.57143",
    stroke: "#292D32",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4284 4L8.97129 10.4571C8.86447 10.5618 8.72086 10.6205 8.57129 10.6205C8.42172 10.6205 8.27811 10.5618 8.17129 10.4571L5.54272 7.82857C5.4359 7.72387 5.29229 7.66522 5.14272 7.66522C4.99314 7.66522 4.84953 7.72387 4.74272 7.82857L0.571289 12",
    stroke: "#292D32",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_1704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIcon);
export default __webpack_public_path__ + "static/media/bill_icon.37b0024b8a2594bba3702397a2e26e2a.svg";
export { ForwardRef as ReactComponent };